import { render, staticRenderFns } from "./nshop-order-list-pg.vue?vue&type=template&id=da004758&scoped=true&"
import script from "./nshop-order-list-pg.vue?vue&type=script&lang=js&"
export * from "./nshop-order-list-pg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da004758",
  null
  
)

export default component.exports